import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Lembrete } from '../model/lembrete/lembrete.model';
import { LembreteCriacao } from '../model/lembrete/lembrete-criacao.model';
import { FiltroLembrete } from '../model/lembrete/filtro-lembrete.model';
import { LembreteContagem } from '../model/lembrete/lembrete-contagem.model';
import { PageModel } from '../model/page-mode.model';
import { TemplateEnvioRedirecionamento } from '../model/template/template-envio-redirecionamento.model';
import { LembreteNotificacao } from '../model/lembrete/lembrete-notificacao.model';

@Injectable({
  providedIn: 'root'
})
export class LembreteService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/lembrete`;

  buscarPorId(id: number): Observable<Lembrete> {
    return this.http.get<Lembrete>(`${this.urlBase}/${id}`);
  }

  resolverRedirecionamentoTemplate(templateId: number): Observable<TemplateEnvioRedirecionamento> {
    return this.http.get<TemplateEnvioRedirecionamento>(`${this.urlBase}/resolver-redirecionamento/${templateId}`, { headers: { 'no-loading': 'true' } });
  }

  criar(lembrete: LembreteCriacao): Observable<number> {
    return this.http.post<number>(this.urlBase, lembrete);
  }

  atualizar(id: number, lembrete: LembreteCriacao): Observable<void> {
    return this.http.patch<void>(`${this.urlBase}/${id}`, lembrete);
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(`${this.urlBase}/${id}`);
  }

  processar(id: number): Observable<void> {
    return this.http.post<void>(`${this.urlBase}/${id}/processar`, {});
  }

  buscarNotificacoes(): Observable<LembreteNotificacao[]> {
    return this.http.get<LembreteNotificacao[]>(`${this.urlBase}/notificacoes`, { headers: { 'no-loading': 'true' } });
  }

  adiar(id: number, minutos: number): Observable<void> {
    return this.http.post<void>(`${this.urlBase}/${id}/adiar`, { minutos }, { headers: { 'no-loading': 'true' } });
  }

  dispensarAviso(id: number): Observable<void> {
    return this.http.post<void>(`${this.urlBase}/${id}/dispensar-aviso`, {}, { headers: { 'no-loading': 'true' } });
  }

  buscarPaginado(filtro: FiltroLembrete, page: number, limit: number): Observable<PageModel> {
    return this.http.post<PageModel>(`${this.urlBase}/buscar-paginados`, filtro, {
      params: { page, limit }
    });
  }

  contarPorStatus(): Observable<LembreteContagem> {
    return this.http.get<LembreteContagem>(`${this.urlBase}/contagem`);
  }

  buscarProximoContato(contatoId: number): Observable<Lembrete | null> {
    return this.http.get<Lembrete | null>(`${this.urlBase}/proximo-contato/${contatoId}`, { headers: { 'no-loading': 'true' } });
  }

  buscarHojeContato(contatoId: number, page: number, limit: number): Observable<PageModel> {
    return this.http.get<PageModel>(`${this.urlBase}/hoje-contato/${contatoId}`, {
      params: { page, limit },
      headers: { 'no-loading': 'true' }
    });
  }

  buscarTodosContato(contatoId: number, concluidos: boolean, crescente: boolean, page: number, limit: number): Observable<PageModel> {
    return this.http.get<PageModel>(`${this.urlBase}/contato/${contatoId}`, {
      params: { concluidos, crescente, page, limit },
      headers: { 'no-loading': 'true' }
    });
  }

  contarPorStatusContato(contatoId: number): Observable<LembreteContagem> {
    return this.http.get<LembreteContagem>(`${this.urlBase}/contagem-status-contato/${contatoId}`, { headers: { 'no-loading': 'true' } });
  }

  contarPendentesContato(contatoId: number): Observable<number> {
    return this.http.get<number>(`${this.urlBase}/contagem-contato/${contatoId}`, { headers: { 'no-loading': 'true' } });
  }

  contarHoje(): Observable<number> {
    return this.http.get<number>(`${this.urlBase}/contagem-hoje`, { headers: { 'no-loading': 'true' } });
  }
}
